import React from "react";
import DriveBrowser from "../components/drive/DriveBrowser";

// Workspace-wide Drive (root). Entity tabs reuse <DriveBrowser> rooted at e:<id>.
export default function Documents() {
  return <DriveBrowser rootId="root" />;
}
